import { applyMiddleware, bindActionCreators, combineReducers, compose, createStore, Store } from 'redux';
import { persistReducer, persistStore } from 'redux-persist';
import { PersistConfig } from "redux-persist/es/types";
import storage from 'redux-persist/lib/storage/session';
import { accountsSlice } from "./slices/accounts";
import { adminSlice } from "./slices/admin";
import { assetsSlice } from "./slices/assets";
import { balancesSlice } from "./slices/balances";
import { clientsSlice } from "./slices/clients";
import { creditSlice } from './slices/credit';
import { equitySlice } from "./slices/equity";
import { marketWidgetsSlice } from "./slices/marketWidgets";
import { portfoliosSlice } from "./slices/portfolios";
import { systemSlice } from "./slices/system";
import { tradableAssetsSlice } from './slices/tradableAssets';
import { userSlice } from "./slices/user";

declare global {
  interface Window {
    __REDUX_DEVTOOLS_EXTENSION_COMPOSE__: any
  }
}

const composeEnhancers =
  typeof window === 'object' &&
  window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ?
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
      // Specify extension’s options like name, actionsBlacklist, actionsCreators, serialize...
    }) : compose;

const enhancer = composeEnhancers(
  applyMiddleware(),
  // other store enhancers if any
);

const reducers = combineReducers({
  admin: adminSlice.reducer,
  user: userSlice.reducer,
  system: systemSlice.reducer,
  balances: balancesSlice.reducer,
  assets: assetsSlice.reducer,
  tradableAssets: tradableAssetsSlice.reducer,
  clients: clientsSlice.reducer,
  accounts: accountsSlice.reducer,
  portfolios: portfoliosSlice.reducer,
  marketWidgets: marketWidgetsSlice.reducer,
  credit: creditSlice.reducer,
  equity: equitySlice.reducer
});

export type AppState = ReturnType<typeof reducers>

const persistConfig: PersistConfig<AppState> = {
  key: 'root',
  whitelist: [
    'user',
  ],
  storage,
}

const persistedReducer = persistReducer<AppState>(persistConfig, reducers)

export const store: Store<AppState> = createStore(persistedReducer, enhancer);
export const persistor = persistStore(store)

export const dispatcher = {
  admin: bindActionCreators(adminSlice.actions, store.dispatch),
  user: bindActionCreators(userSlice.actions, store.dispatch),
  system: bindActionCreators(systemSlice.actions, store.dispatch),
  balances: bindActionCreators(balancesSlice.actions, store.dispatch),
  assets: bindActionCreators(assetsSlice.actions, store.dispatch),
  tradableAssets: bindActionCreators(tradableAssetsSlice.actions, store.dispatch),
  clients: bindActionCreators(clientsSlice.actions, store.dispatch),
  accounts: bindActionCreators(accountsSlice.actions, store.dispatch),
  portfolios: bindActionCreators(portfoliosSlice.actions, store.dispatch),
  marketWidgets: bindActionCreators(marketWidgetsSlice.actions, store.dispatch),
  credit: bindActionCreators(creditSlice.actions, store.dispatch),
  equity: bindActionCreators(equitySlice.actions, store.dispatch)
};
